import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import { Stack } from "@mui/material";
import InvestmentMainChart from "src/scenes/overview/overview-components/investment-main-chart";
import DeliveryThroughputChart from "src/scenes/overview/overview-components/delivery-throughput-chart";
import DeliveryLeadTimeChart from "src/scenes/overview/overview-components/delivery-leadtime-chart";
import DeliveryScopeCreepChart from "src/scenes/overview/overview-components/delivery-scope-creep-chart";
import DeliveryReviewTimeChart from "src/scenes/overview/overview-components/delivery-review-time-chart";
import CreditExpenditureMainChart from "src/scenes/overview/overview-components/credit-expenditure-main-chart";
import CreditExpenditureBacklogChart from "src/scenes/overview/overview-components/credit-expediture-backlog-chart";
import CreditExpenditureReworkChart from "src/scenes/overview/overview-components/credit-expediture-rework-chart";
import CreditExpenditureMaintainabilityChart from "src/scenes/overview/overview-components/credit-expediture-maintainability-chart";
import CreditExpenditureSilosChart from "src/scenes/overview/overview-components/credit-expediture-silos-chart";
import CreditExpenditureBugsDetectedChart from "src/scenes/overview/overview-components/credit-expediture-bugs-detected-chart";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -51%)",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    width: "90%",
    maxHeight: "95vh",
};

const HeaderStack = styled(Stack)`
    width: 100%;
    background-color: #5b5b5b;
    padding: 4px 8px 2px 16px;
    border-radius: 14px 14px 0 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
const OverviewExpandModal = ({
    data,
    status,
    expandedChart,
    setExpandedChart,
    codeQualityActivated,
}) => {
    const handleClose = () => setExpandedChart(undefined);

    const getTitle = {
        investment: "Investment",
        throughput: "Throughput",
        leadTime: "Lead Time",
        scopeCreep: "Sprint Planning (In)Accuracy",
        reviewTime: "Review Time",
        creditCost: "Personal Credit Cost",
        backlogSize: "Backlog Size",
        bugsDetected: "Bugs Detected",
        rework: "Reworked Code",
        maintainability: "Maintainability Index Changes",
        codeSilos: "Code Silos",
    };
    const getChart = () => {
        if (!expandedChart) return null;
        if (expandedChart === "investment")
            return <InvestmentMainChart data={data} status={status} isExpanded />;
        if (expandedChart === "throughput")
            return <DeliveryThroughputChart data={data.throughput} status={status} isExpanded />;
        if (expandedChart === "leadTime")
            return <DeliveryLeadTimeChart data={data.leadTime} isExpanded />;
        if (expandedChart === "scopeCreep")
            return <DeliveryScopeCreepChart data={data.scopeCreep} isExpanded />;
        if (expandedChart === "reviewTime")
            return <DeliveryReviewTimeChart data={data.reviewTime} isExpanded />;
        if (expandedChart === "creditCost")
            return <CreditExpenditureMainChart data={data} status={status} isExpanded />;
        if (expandedChart === "backlogSize")
            return <CreditExpenditureBacklogChart data={data} status={status} isExpanded />;
        if (expandedChart === "bugsDetected")
            return <CreditExpenditureBugsDetectedChart data={data.bugsDetected} isExpanded />;
        if (expandedChart === "rework")
            return <CreditExpenditureReworkChart data={data.rework} isExpanded />;
        if (expandedChart === "maintainability")
            return (
                <CreditExpenditureMaintainabilityChart
                    data={data.maintainability}
                    codeQualityActivated={codeQualityActivated}
                    isExpanded
                />
            );
        if (expandedChart === "codeSilos")
            return <CreditExpenditureSilosChart data={data.codeSilos} isExpanded />;
        return null;
    };

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={expandedChart}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={expandedChart}>
                    <Box sx={style}>
                        <HeaderStack>
                            <Typography id="transition-modal-title" style={{ fontSize: "14px" }}>
                                {getTitle[expandedChart]}
                            </Typography>
                        </HeaderStack>
                        {getChart()}
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default OverviewExpandModal;
